var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.37827C0 1.96022 1.96022 0 4.37827 0H79.5386C81.9567 0 83.9169 1.96022 83.9169 4.37827V70.7821C83.9169 73.2001 81.9567 75.1603 79.5386 75.1603H4.37827C1.96022 75.1603 0 73.2001 0 70.7821V4.37827ZM8.75654 8.75654V66.4038H75.1603V8.75654H8.75654Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7806 70.7812C19.1987 70.7812 21.1589 72.7415 21.1589 75.1595L21.1589 79.5378C21.1589 81.9559 19.1987 83.9161 16.7806 83.9161C14.3626 83.9161 12.4023 81.9559 12.4023 79.5378L12.4023 75.1595C12.4023 72.7415 14.3626 70.7812 16.7806 70.7812Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8633 20.4323C13.8633 18.0142 15.8235 16.054 18.2416 16.054L26.9981 16.054C29.4161 16.054 31.3764 18.0142 31.3764 20.4323C31.3764 22.8503 29.4161 24.8105 26.9981 24.8105L18.2416 24.8105C15.8235 24.8105 13.8633 22.8503 13.8633 20.4323Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5391 20.4323C52.5391 18.0142 54.4993 16.054 56.9173 16.054L65.6739 16.054C68.0919 16.054 70.0522 18.0142 70.0522 20.4323C70.0522 22.8503 68.0919 24.8105 65.6739 24.8105L56.9173 24.8105C54.4993 24.8105 52.5391 22.8503 52.5391 20.4323Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8633 33.567C13.8633 31.149 15.8235 29.1888 18.2416 29.1888L26.9981 29.1888C29.4161 29.1888 31.3764 31.149 31.3764 33.567C31.3764 35.9851 29.4161 37.9453 26.9981 37.9453L18.2416 37.9453C15.8235 37.9453 13.8633 35.9851 13.8633 33.567Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5391 33.567C52.5391 31.149 54.4993 29.1888 56.9173 29.1888L65.6739 29.1888C68.0919 29.1888 70.0522 31.149 70.0522 33.567C70.0522 35.9851 68.0919 37.9453 65.6739 37.9453L56.9173 37.9453C54.4993 37.9453 52.5391 35.9851 52.5391 33.567Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1322 70.7812C69.5502 70.7812 71.5105 72.7415 71.5105 75.1595L71.5105 79.5378C71.5105 81.9559 69.5502 83.9161 67.1322 83.9161C64.7141 83.9161 62.7539 81.9559 62.7539 79.5378L62.7539 75.1595C62.7539 72.7415 64.7141 70.7812 67.1322 70.7812Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5781 70.781V8.39062H46.3347V70.781H37.5781Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/Locker.d5c9c73f3b0ccfa4b0d7af661863ec61.svg";
export { ForwardRef as ReactComponent };